
import { Component, Vue } from 'vue-property-decorator';
import BaseHeader from '@/components/BaseHeader.vue';
import { ValidationObserver } from 'vee-validate';
import BaseFieldUpload from '@/components/form/BaseFieldUpload.vue';

@Component({
  components: {
    BaseHeader,
    ValidationObserver,
    BaseFieldUpload,
  },
})
export default class NewClaimProofUpload extends Vue {
  isLoading = false;

  get uploadRules(): any {
    return {
      required: true,
      ext: ['pdf', 'jpg', 'jpeg', 'png', 'msg', 'docx', 'xlsx'],
      totalSize: 25, // Upload limit of 25Mb
    };
  }
}
